import invariant from 'ts-invariant';
import qs from 'qs';
import { getUserDeviceId } from '@gaoding/user-device-id';
import axios from 'axios';
import { localCache } from '@gaoding/cache';
import Cookies from 'js-cookie';
import { Base64 } from 'js-base64';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var Env;
(function (Env) {
    Env["Dev"] = "dev";
    Env["Stage"] = "stage";
    Env["Prod"] = "prod";
    Env["Fat"] = "fat";
})(Env || (Env = {}));
var TokenSourceType;
(function (TokenSourceType) {
    TokenSourceType["LocalStorage"] = "localStorage";
    TokenSourceType["Iframe"] = "iframe";
    TokenSourceType["Electron"] = "electron";
})(TokenSourceType || (TokenSourceType = {}));

function paddingProtocol(url) {
    if (url.startsWith('http')) {
        return url;
    }
    if (typeof location !== 'undefined' && location.protocol.startsWith('http')) {
        return location.protocol + "//" + url;
    }
    return "https://" + url;
}

var _a;
var TOKEN_KEY = 'token';
var ORG_ID_KEY = 'token.org_id';
var EXTRA_DATA = 'UMS_EXTRA_DATA__';
var REFRESHING_TOKEN_KEY = 'refreshing_token';
var TIME_FACTOR = 30 * 1000;
var inBrowser = typeof window !== 'undefined';
var DEFAULT_CLIENTID = 'gaodingx';
var envConfigMap = (_a = {},
    _a[Env.Dev] = {
        clientId: DEFAULT_CLIENTID,
        clientSecret: '7da458070e57b98e11d00d9286f23537',
        tokenEndpoint: paddingProtocol('ums.dev.gaoding.com/connect/oauth/tokens'),
        authorizationEndpoint: paddingProtocol('ums.dev.gaoding.com/oauth2/authorize'),
        redirectURI: paddingProtocol('www.dev.gaoding.com/api/ums/redirect'),
        iframeTokenSourceURL: paddingProtocol('ums.dev.gaoding.com/oauth2/source'),
        qiyeSsoURI: paddingProtocol('sso.my-dev.gaoding.com'),
    },
    _a[Env.Fat] = {
        clientId: DEFAULT_CLIENTID,
        clientSecret: '7da458070e57b98e11d00d9286f23537',
        tokenEndpoint: paddingProtocol('ums-fat.gaoding.com/connect/oauth/tokens'),
        authorizationEndpoint: paddingProtocol('ums-fat.gaoding.com/oauth2/authorize'),
        redirectURI: paddingProtocol('fat.gaoding.com/api/ums/redirect'),
        iframeTokenSourceURL: paddingProtocol('ums-fat.gaoding.com/oauth2/source'),
        qiyeSsoURI: paddingProtocol('sso.my-fat.gaoding.com'),
    },
    _a[Env.Stage] = {
        clientId: DEFAULT_CLIENTID,
        clientSecret: '7da458070e57b98e11d00d9286f23537',
        tokenEndpoint: paddingProtocol('ums-stage.gaoding.com/connect/oauth/tokens'),
        authorizationEndpoint: paddingProtocol('ums-stage.gaoding.com/oauth2/authorize'),
        redirectURI: paddingProtocol('stage.gaoding.com/api/ums/redirect'),
        iframeTokenSourceURL: paddingProtocol('ums-stage.gaoding.com/oauth2/source'),
        qiyeSsoURI: paddingProtocol('sso.my-stage.gaoding.com'),
    },
    _a[Env.Prod] = {
        clientId: DEFAULT_CLIENTID,
        clientSecret: '7da458070e57b98e11d00d9286f23537',
        tokenEndpoint: paddingProtocol('ums.gaoding.com/connect/oauth/tokens'),
        authorizationEndpoint: paddingProtocol('ums.gaoding.com/oauth2/authorize'),
        redirectURI: paddingProtocol('www.gaoding.com/api/ums/redirect'),
        iframeTokenSourceURL: paddingProtocol('ums.gaoding.com/oauth2/source'),
        qiyeSsoURI: paddingProtocol('sso.my.gaoding.com'),
    },
    _a);

function snakeCaseKeys(o) {
    var keys = Object.keys(o);
    var result = {};
    keys.forEach(function (key) {
        var snakeCaseKey = key.replace(/([a-z])([A-Z])/g, function (m, a, b) { return a + '_' + b.toLowerCase(); });
        result[snakeCaseKey] = o[key];
    });
    return result;
}

var AccessTokenRequest = /** @class */ (function () {
    function AccessTokenRequest(params) {
        this.params = params;
    }
    AccessTokenRequest.prototype.toSnakeCase = function () {
        return snakeCaseKeys(this.params);
    };
    return AccessTokenRequest;
}());
var PasswordRequest = /** @class */ (function (_super) {
    __extends(PasswordRequest, _super);
    function PasswordRequest(params) {
        var _this = _super.call(this, params) || this;
        _this.params = params;
        return _this;
    }
    return PasswordRequest;
}(AccessTokenRequest));
var VerifyCodeRequest = /** @class */ (function (_super) {
    __extends(VerifyCodeRequest, _super);
    function VerifyCodeRequest(params) {
        var _this = _super.call(this, params) || this;
        _this.params = params;
        return _this;
    }
    return VerifyCodeRequest;
}(AccessTokenRequest));
var AuthorizationCodeRequest = /** @class */ (function (_super) {
    __extends(AuthorizationCodeRequest, _super);
    function AuthorizationCodeRequest(params) {
        var _this = _super.call(this, params) || this;
        _this.params = params;
        return _this;
    }
    return AuthorizationCodeRequest;
}(AccessTokenRequest));
var ThirdPartyRequest = /** @class */ (function (_super) {
    __extends(ThirdPartyRequest, _super);
    function ThirdPartyRequest(params) {
        var _this = _super.call(this, params) || this;
        _this.params = params;
        return _this;
    }
    return ThirdPartyRequest;
}(AccessTokenRequest));
var RefreshTokenRequest = /** @class */ (function (_super) {
    __extends(RefreshTokenRequest, _super);
    function RefreshTokenRequest(params) {
        var _this = _super.call(this, params) || this;
        _this.params = params;
        return _this;
    }
    return RefreshTokenRequest;
}(AccessTokenRequest));
var RefreshOrgIdRequest = /** @class */ (function () {
    function RefreshOrgIdRequest(params) {
        this.params = params;
        this.params = params;
    }
    RefreshOrgIdRequest.prototype.toSnakeCase = function () {
        return snakeCaseKeys(this.params);
    };
    return RefreshOrgIdRequest;
}());

function getOS() {
    var platform = navigator.platform.toLowerCase();
    if (platform === 'win32' || platform === 'windows') {
        return 'windows';
    }
    if (platform.includes('mac')) {
        return 'mac os';
    }
    if (platform === 'x11') {
        return 'unix';
    }
    if (platform.includes('linux')) {
        return 'linux';
    }
    return 'unknown';
}

var http = axios.create();
http.interceptors.response.use(function (response) { return response; }, function (error) {
    if (error.response) {
        var response = error.response;
        if (response.data) {
            return Promise.reject(response.data);
        }
        var err = new Error(response.status + response.statusText);
        return Promise.reject(err);
    }
    return Promise.reject(error);
});

var DEFAULT_DOMAIN = '.gaoding.com';
/**
 * https://doc.huanleguang.com/pages/viewpage.action?pageId=220571495
 * 暂时只支持往 gaodingx 种 cookie
 */
var Cookie = /** @class */ (function () {
    function Cookie(client, tokenKey) {
        this.isDefauleClient = false; // gaodingx
        this.tokenKey = '';
        var _a = client.config, env = _a.env, clientId = _a.clientId;
        var key = tokenKey + "." + env;
        this.tokenKey = key;
        if (clientId === DEFAULT_CLIENTID) {
            this.isDefauleClient = true;
        }
    }
    Cookie.prototype.set = function (key, value) {
        if (!this.isDefauleClient) {
            return;
        }
        Cookies.set(key, value, { domain: DEFAULT_DOMAIN });
    };
    Cookie.prototype.get = function (key) {
        return Cookies.get(key) || '';
    };
    Cookie.prototype.clear = function (key) {
        if (!this.isDefauleClient) {
            return;
        }
        Cookies.remove(key, { domain: DEFAULT_DOMAIN });
    };
    Cookie.prototype.setToken = function (token) {
        if (!this.isDefauleClient) {
            return;
        }
        Cookies.set(this.tokenKey, Base64.encode(token), { domain: DEFAULT_DOMAIN });
    };
    Cookie.prototype.getToken = function () {
        var ck = Cookies.get(this.tokenKey) || '';
        return Base64.decode(ck);
    };
    Cookie.prototype.clearToken = function () {
        if (!this.isDefauleClient) {
            return;
        }
        Cookies.remove(this.tokenKey, { domain: DEFAULT_DOMAIN });
    };
    return Cookie;
}());

function sleep(timeout) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) {
                    setTimeout(function () {
                        resolve();
                    }, timeout);
                })];
        });
    });
}

var TIMEOUT = 30;
var LocalStorageTokenSource = /** @class */ (function () {
    function LocalStorageTokenSource(client) {
        var _this = this;
        this.client = client;
        this._queue = [];
        this._listenRefreshingTokenChange = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var key, newValue, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        key = event.key, newValue = event.newValue;
                        if (key === null) {
                            this._flushRefreshTokenQueue(null);
                            return [2 /*return*/];
                        }
                        if (key !== this._refreshingTokenKey) {
                            return [2 /*return*/];
                        }
                        if (!(newValue === null)) return [3 /*break*/, 2];
                        this._log('Other client end refreshing token.');
                        _a = this._flushRefreshTokenQueue;
                        _b = [null];
                        return [4 /*yield*/, this._getToken()];
                    case 1:
                        _a.apply(this, _b.concat([_c.sent()]));
                        this._clearRefreshTokenTimeout();
                        return [2 /*return*/];
                    case 2:
                        this._log('Other client start refreshing token.');
                        return [2 /*return*/];
                }
            });
        }); };
        var _a = client.config, env = _a.env, clientId = _a.clientId;
        this._tokenKey = TOKEN_KEY;
        this._orgId = ORG_ID_KEY + "." + env;
        if (client.config.scopeToken) {
            this._tokenKey = clientId + "." + TOKEN_KEY;
        }
        if (client.config.tokenKey) {
            this._tokenKey = client.config.tokenKey;
        }
        if (client.config.refreshingTokenKey) {
            this._refreshingTokenKey = client.config.refreshingTokenKey;
        }
        if (!client.config.refreshingTokenKey && client.config.tokenSourceType === TokenSourceType.LocalStorage) {
            this._refreshingTokenKey = REFRESHING_TOKEN_KEY;
        }
        else {
            this._refreshingTokenKey = clientId + "." + REFRESHING_TOKEN_KEY;
        }
        this._cookie = new Cookie(client, this._tokenKey);
        window.addEventListener('storage', this._listenRefreshingTokenChange, false);
        this._init();
    }
    LocalStorageTokenSource.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isRefreshingToken, token, accessToken, accessTokenExpiresIn, accessTokenLifeTime, accessTokenExpiresAt, refreshToken, refreshTokenExpiresIn, refreshTokenLifeTime, refreshTokenExpiresAt, timestamp;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._log('Getting access token...');
                        isRefreshingToken = this._isRefreshingToken();
                        if (isRefreshingToken) {
                            this._log('Refreshing token...');
                            return [2 /*return*/, new Promise(function (resolve, reject) {
                                    _this._queue.push({
                                        fulfilled: resolve,
                                        rejected: reject
                                    });
                                })];
                        }
                        return [4 /*yield*/, this._getToken()];
                    case 1:
                        token = _a.sent();
                        if (!token) {
                            this._log('Token is empty.');
                            return [2 /*return*/];
                        }
                        accessToken = token.access_token;
                        accessTokenExpiresIn = token.expires_in;
                        accessTokenLifeTime = token.access_token_life_time;
                        accessTokenExpiresAt = token.access_token_expires_at;
                        refreshToken = token.refresh_token;
                        refreshTokenExpiresIn = token.refresh_token_expires_in;
                        refreshTokenLifeTime = token.refresh_token_life_time;
                        refreshTokenExpiresAt = token.refresh_token_expires_at;
                        timestamp = token.timestamp;
                        if (accessToken &&
                            !this._tokenIsExpired(timestamp, accessTokenLifeTime || accessTokenExpiresIn, accessTokenExpiresAt)) {
                            this._log('Access token:', accessToken);
                            return [2 /*return*/, accessToken];
                        }
                        this._log('Access token expired.');
                        if (!refreshToken ||
                            this._tokenIsExpired(timestamp, refreshTokenLifeTime || refreshTokenExpiresIn, refreshTokenExpiresAt)) {
                            this.clearToken();
                            this._log('Refresh token expired.');
                            return [2 /*return*/];
                        }
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                _this._queue.push({
                                    fulfilled: resolve,
                                    rejected: reject
                                });
                                _this._handleRefreshToken(token);
                            })];
                }
            });
        });
    };
    LocalStorageTokenSource.prototype._tokenIsExpired = function (timestamp, lifeTime, expiresAt) {
        if (timestamp && lifeTime) {
            return timestamp + lifeTime * 1000 < Date.now() + TIME_FACTOR;
        }
        if (expiresAt) {
            return Date.parse(expiresAt) < Date.now() + TIME_FACTOR;
        }
        return true;
    };
    LocalStorageTokenSource.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._getToken()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LocalStorageTokenSource.prototype.setToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var _token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _token = JSON.stringify(token);
                        localCache.setItem(this._tokenKey, _token);
                        this._cookie.setToken(_token);
                        if (!(token && token.org_id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setOrgId(token.org_id)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    LocalStorageTokenSource.prototype.setOrgId = function (org_id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                localCache.setItem(this._orgId, org_id);
                this._cookie.set(this._orgId, org_id);
                return [2 /*return*/];
            });
        });
    };
    LocalStorageTokenSource.prototype.getOrgId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ckOrgId, lSorgId;
            return __generator(this, function (_a) {
                ckOrgId = this._cookie.get(this._orgId);
                lSorgId = localCache.getItem(this._orgId);
                if (!lSorgId && ckOrgId) {
                    localCache.setItem(this._orgId, ckOrgId);
                }
                if (lSorgId && !ckOrgId) {
                    this._cookie.set(this._orgId, lSorgId);
                }
                return [2 /*return*/, ckOrgId || lSorgId || ''];
            });
        });
    };
    LocalStorageTokenSource.prototype.setExtraData = function (key, data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                localCache.setItem("" + EXTRA_DATA + key, JSON.stringify(data));
                return [2 /*return*/];
            });
        });
    };
    LocalStorageTokenSource.prototype.getExtraData = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var extraData, parsed;
            return __generator(this, function (_a) {
                extraData = localCache.getItem("" + EXTRA_DATA + key);
                if (extraData) {
                    try {
                        parsed = JSON.parse(extraData);
                        return [2 /*return*/, parsed];
                        /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
                    }
                    catch (error) {
                        // ignore error
                        return [2 /*return*/, null];
                    }
                }
                return [2 /*return*/, null];
            });
        });
    };
    LocalStorageTokenSource.prototype.clearToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token, access_token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getToken()];
                    case 1:
                        token = _a.sent();
                        access_token = (token === null || token === void 0 ? void 0 : token.access_token) || '';
                        localCache.removeItem(this._tokenKey);
                        localCache.removeItem(this._orgId);
                        this._cookie.clearToken();
                        return [4 /*yield*/, this.client.launchreClearToken({ access_token: access_token })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LocalStorageTokenSource.prototype._startRefreshToken = function () {
        this._log('Start refreshing token.');
        localCache.setItem(this._refreshingTokenKey, '1');
    };
    LocalStorageTokenSource.prototype._endRefreshToken = function () {
        this._log('End refreshing token.');
        localCache.removeItem(this._refreshingTokenKey);
    };
    LocalStorageTokenSource.prototype._init = function () {
        var isRefreshingToken = this._isRefreshingToken();
        if (isRefreshingToken) {
            this._handleRefreshTokenTimeout();
        }
    };
    LocalStorageTokenSource.prototype._getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ckToken, lStoken, parsed;
            return __generator(this, function (_a) {
                ckToken = this._cookie.getToken();
                lStoken = localCache.getItem(this._tokenKey) || '';
                // 同步 cookie token 到 localStorage
                if (!lStoken && ckToken) {
                    localCache.setItem(this._tokenKey, ckToken);
                }
                // 同步 localStorage token 到 cookie
                if (lStoken && !ckToken) {
                    this._cookie.setToken(lStoken);
                }
                if (ckToken || lStoken) {
                    try {
                        parsed = JSON.parse(ckToken || lStoken);
                        return [2 /*return*/, parsed];
                        /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
                    }
                    catch (error) {
                        // ignore error
                        return [2 /*return*/, null];
                    }
                }
                return [2 /*return*/, null];
            });
        });
    };
    LocalStorageTokenSource.prototype._isRefreshingToken = function () {
        var refreshingToken = localCache.getItem(this._refreshingTokenKey);
        return Boolean(refreshingToken);
    };
    LocalStorageTokenSource.prototype._flushRefreshTokenQueue = function (error, token) {
        return __awaiter(this, void 0, void 0, function () {
            var queue, status_1, newToken, newAccessToken, accessToken, action, fulfilled, rejected;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queue = this._queue;
                        this._log('Start flushing get access token queue.');
                        this._log('Queue length:', queue.length);
                        if (error) {
                            this._log('Flushing by error:', error);
                        }
                        this._log('Flushing by token:', token);
                        if (!(error === null || error === void 0 ? void 0 : error.status)) return [3 /*break*/, 4];
                        status_1 = error.status;
                        if (!/^4\d\d/.test(status_1)) return [3 /*break*/, 4];
                        if (!(status_1 === 400)) return [3 /*break*/, 3];
                        // 对于多浏览器标签页，存在使用同一个 refresh token 并发请求刷新 token 的情况，常见于同时刷新标签页。
                        // 并发刷新 token 会遇到以下情况：
                        // 1. 请求都为成功；
                        // 2. 存在至少一个请求成功，其它返回 invalid_refresh_token 错误。
                        //
                        // 当遇到 invalid_refresh_token 时，检查 token 是否已经刷新。
                        // 若 token 已刷新，则忽略错误。
                        this._log('Invalid_refresh_token error encountered.');
                        this._log('Sleeping 10s ...');
                        return [4 /*yield*/, sleep(10000)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this._getToken()];
                    case 2:
                        newToken = _a.sent();
                        newAccessToken = newToken === null || newToken === void 0 ? void 0 : newToken.access_token;
                        this._log('Get current access token:', newAccessToken);
                        this._log('Compare with previous access token:', this._oldAccessToken);
                        if (newAccessToken && newAccessToken !== this._oldAccessToken) {
                            this._log('Token had refreshed by other client.');
                            token = newToken;
                            error = null;
                        }
                        else {
                            this.clearToken();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        this.clearToken();
                        _a.label = 4;
                    case 4:
                        accessToken = token === null || token === void 0 ? void 0 : token.access_token;
                        while (queue.length) {
                            action = queue.shift();
                            if (!action) {
                                continue;
                            }
                            fulfilled = action.fulfilled, rejected = action.rejected;
                            if (error) {
                                rejected(error);
                            }
                            else {
                                fulfilled(accessToken);
                            }
                        }
                        this._log('End flushing get access token queue.');
                        return [2 /*return*/];
                }
            });
        });
    };
    LocalStorageTokenSource.prototype._clearRefreshTokenTimeout = function () {
        if (this._timer) {
            window.clearTimeout(this._timer);
            this._timer = undefined;
        }
    };
    LocalStorageTokenSource.prototype._handleRefreshToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var orgId, headers, deviceId, newToken, currentToken, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._oldAccessToken = token.access_token;
                        this._startRefreshToken();
                        return [4 /*yield*/, this.getOrgId()];
                    case 1:
                        orgId = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 8, , 10]);
                        headers = {};
                        deviceId = this.client.config.deviceId ? this.client.config.deviceId : getUserDeviceId();
                        if (deviceId) {
                            headers['X-Guest-Token'] = deviceId;
                        }
                        return [4 /*yield*/, this.client.launchRefreshTokenFlow({ refreshToken: token.refresh_token }, headers)];
                    case 3:
                        newToken = _a.sent();
                        if (!orgId) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.client.launchreRreshOrgIdFlow({
                                org_id: orgId,
                                access_token: newToken.access_token,
                                refresh_token: newToken.refresh_token
                            })];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        this._log('Receive new token:', newToken);
                        return [4 /*yield*/, this._getToken()];
                    case 6:
                        currentToken = _a.sent();
                        // 并发请求 token 且都返回新的 token，则有效期长的优先写入，避免 refresh_token 被覆盖导致下次刷新 token 返回 invalid_refresh_token 错误
                        if (currentToken && newToken.refresh_token_expires_at && currentToken.refresh_token_expires_at) {
                            if (Date.parse(newToken.refresh_token_expires_at) >= Date.parse(currentToken.refresh_token_expires_at)) {
                                this._log('New token is more fresh than current token.');
                                this.setToken(newToken);
                            }
                            else {
                                this._log('Current token is more fresh than new token.');
                            }
                        }
                        else {
                            this.setToken(newToken);
                        }
                        return [4 /*yield*/, this._flushRefreshTokenQueue(null, newToken)];
                    case 7:
                        _a.sent();
                        return [3 /*break*/, 10];
                    case 8:
                        error_1 = _a.sent();
                        return [4 /*yield*/, this._flushRefreshTokenQueue(error_1)];
                    case 9:
                        _a.sent();
                        return [3 /*break*/, 10];
                    case 10:
                        this._oldAccessToken = undefined;
                        this._endRefreshToken();
                        return [2 /*return*/];
                }
            });
        });
    };
    LocalStorageTokenSource.prototype._retryRefreshToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token, accessToken, accessTokenExpiresIn, accessTokenLifeTime, accessTokenExpiresAt, refreshToken, refreshTokenExpiresIn, refreshTokenLifeTime, refreshTokenExpiresAt, timestamp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._log('Start retry refreshing token.');
                        return [4 /*yield*/, this._getToken()];
                    case 1:
                        token = _a.sent();
                        accessToken = token === null || token === void 0 ? void 0 : token.access_token;
                        accessTokenExpiresIn = token === null || token === void 0 ? void 0 : token.expires_in;
                        accessTokenLifeTime = token === null || token === void 0 ? void 0 : token.access_token_life_time;
                        accessTokenExpiresAt = token === null || token === void 0 ? void 0 : token.access_token_expires_at;
                        refreshToken = token === null || token === void 0 ? void 0 : token.refresh_token;
                        refreshTokenExpiresIn = token === null || token === void 0 ? void 0 : token.refresh_token_expires_in;
                        refreshTokenLifeTime = token === null || token === void 0 ? void 0 : token.refresh_token_life_time;
                        refreshTokenExpiresAt = token === null || token === void 0 ? void 0 : token.refresh_token_expires_at;
                        timestamp = token === null || token === void 0 ? void 0 : token.timestamp;
                        if (accessToken &&
                            !this._tokenIsExpired(timestamp, accessTokenLifeTime || accessTokenExpiresIn, accessTokenExpiresAt)) {
                            this._flushRefreshTokenQueue(null, token);
                            this._endRefreshToken();
                            return [2 /*return*/];
                        }
                        if (!refreshToken ||
                            this._tokenIsExpired(timestamp, refreshTokenLifeTime || refreshTokenExpiresIn, refreshTokenExpiresAt)) {
                            this.clearToken();
                            this._flushRefreshTokenQueue(null);
                            this._endRefreshToken();
                            return [2 /*return*/];
                        }
                        this._handleRefreshToken(token);
                        return [2 /*return*/];
                }
            });
        });
    };
    LocalStorageTokenSource.prototype._handleRefreshTokenTimeout = function () {
        var _this = this;
        this._timer = window.setTimeout(function () {
            _this._retryRefreshToken();
            _this._timer = undefined;
        }, TIMEOUT);
    };
    LocalStorageTokenSource.prototype._log = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (this.client.debug) {
            console.log.apply(console, __spreadArrays(["[LocalStorageTokenSource] " + message], optionalParams));
        }
    };
    return LocalStorageTokenSource;
}());

// @ts-nocheck
/**
 * The type of messages our frames our sending
 * @type {String}
 */
var messageType = 'application/x-postmate-v1+json';
/**
 * The maximum number of attempts to send a handshake request to the parent
 * @type {Number}
 */
var maxHandshakeRequests = 5;
/**
 * A unique message ID that is used to ensure responses are sent to the correct requests
 * @type {Number}
 */
var _messageId = 0;
/**
 * Increments and returns a message ID
 * @return {Number} A unique ID for a message
 */
var generateNewMessageId = function () { return ++_messageId; };
/**
 * Postmate logging function that enables/disables via config
 * @param  {Object} ...args Rest Arguments
 */
var log = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return Postmate.debug ? console.log.apply(console, args) : null;
}; // eslint-disable-line no-console
/**
 * Takes a URL and returns the origin
 * @param  {String} url The full URL being requested
 * @return {String}     The URLs origin
 */
var resolveOrigin = function (url) {
    var a = document.createElement('a');
    a.href = url;
    var protocol = a.protocol.length > 4 ? a.protocol : window.location.protocol;
    var host = a.host.length ? ((a.port === '80' || a.port === '443') ? a.hostname : a.host) : window.location.host;
    return a.origin || protocol + "//" + host;
};
var messageTypes = {
    handshake: 1,
    'handshake-reply': 1,
    call: 1,
    emit: 1,
    reply: 1,
    request: 1,
};
/**
 * Ensures that a message is safe to interpret
 * @param  {Object} message The postmate message being sent
 * @param  {String|Boolean} allowedOrigin The whitelisted origin or false to skip origin check
 * @return {Boolean}
 */
var sanitize = function (message, allowedOrigin) {
    if (typeof allowedOrigin === 'string' &&
        message.origin !== allowedOrigin)
        return false;
    if (!message.data)
        return false;
    if (typeof message.data === 'object' &&
        !('postmate' in message.data))
        return false;
    if (message.data.type !== messageType)
        return false;
    if (!messageTypes[message.data.postmate])
        return false;
    return true;
};
/**
 * Takes a model, and searches for a value by the property
 * @param  {Object} model     The dictionary to search against
 * @param  {String} property  A path within a dictionary (i.e. 'window.location.href')
 * @param  {Object} data      Additional information from the get request that is
 *                            passed to functions in the child model
 * @return {Promise}
 */
var resolveValue = function (model, property, data) {
    var unwrappedContext = typeof model[property] === 'function'
        ? model[property](data) : model[property];
    return Postmate.Promise.resolve(unwrappedContext);
};
/**
 * Composes an API to be used by the parent
 * @param {Object} info Information on the consumer
 */
var ParentAPI = /** @class */ (function () {
    function ParentAPI(info) {
        var _this = this;
        this.parent = info.parent;
        this.frame = info.frame;
        this.child = info.child;
        this.childOrigin = info.childOrigin;
        this.events = {};
        if (process.env.NODE_ENV !== 'production') {
            log('Parent: Registering API');
            log('Parent: Awaiting messages...');
        }
        this.listener = function (e) {
            if (!sanitize(e, _this.childOrigin))
                return false;
            /**
             * the assignments below ensures that e, data, and value are all defined
             */
            var _a = (((e || {}).data || {}).value || {}), data = _a.data, name = _a.name;
            if (e.data.postmate === 'emit') {
                if (process.env.NODE_ENV !== 'production') {
                    log("Parent: Received event emission: " + name);
                }
                if (name in _this.events) {
                    _this.events[name].forEach(function (callback) {
                        callback.call(_this, data);
                    });
                }
            }
        };
        this.parent.addEventListener('message', this.listener, false);
        if (process.env.NODE_ENV !== 'production') {
            log('Parent: Awaiting event emissions from Child');
        }
    }
    ParentAPI.prototype.get = function (property, data) {
        var _this = this;
        return new Postmate.Promise(function (resolve) {
            // Extract data from response and kill listeners
            var uid = generateNewMessageId();
            var transact = function (e) {
                if (e.data.uid === uid && e.data.postmate === 'reply') {
                    _this.parent.removeEventListener('message', transact, false);
                    resolve(e.data.value);
                }
            };
            // Prepare for response from Child...
            _this.parent.addEventListener('message', transact, false);
            // Then ask child for information
            _this.child.postMessage({
                postmate: 'request',
                type: messageType,
                property: property,
                data: data,
                uid: uid,
            }, _this.childOrigin);
        });
    };
    ParentAPI.prototype.call = function (property, data) {
        // Send information to the child
        this.child.postMessage({
            postmate: 'call',
            type: messageType,
            property: property,
            data: data,
        }, this.childOrigin);
    };
    ParentAPI.prototype.on = function (eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = [];
        }
        this.events[eventName].push(callback);
    };
    ParentAPI.prototype.destroy = function () {
        if (process.env.NODE_ENV !== 'production') {
            log('Parent: Destroying Postmate instance');
        }
        window.removeEventListener('message', this.listener, false);
        this.frame.parentNode.removeChild(this.frame);
    };
    return ParentAPI;
}());
/**
 * Composes an API to be used by the child
 * @param {Object} info Information on the consumer
 */
var ChildAPI = /** @class */ (function () {
    function ChildAPI(info) {
        var _this = this;
        this.model = info.model;
        this.parent = info.parent;
        this.parentOrigin = info.parentOrigin;
        this.child = info.child;
        if (process.env.NODE_ENV !== 'production') {
            log('Child: Registering API');
            log('Child: Awaiting messages...');
        }
        this.child.addEventListener('message', function (e) {
            if (!sanitize(e, _this.parentOrigin))
                return;
            if (process.env.NODE_ENV !== 'production') {
                log('Child: Received request', e.data);
            }
            var _a = e.data, property = _a.property, uid = _a.uid, data = _a.data;
            if (e.data.postmate === 'call') {
                if (property in _this.model && typeof _this.model[property] === 'function') {
                    _this.model[property](data);
                }
                return;
            }
            // Reply to Parent
            resolveValue(_this.model, property, data)
                .then(function (value) { return e.source.postMessage({
                property: property,
                postmate: 'reply',
                type: messageType,
                uid: uid,
                value: value,
            }, e.origin); });
        });
    }
    ChildAPI.prototype.emit = function (name, data) {
        if (process.env.NODE_ENV !== 'production') {
            log("Child: Emitting Event \"" + name + "\"", data);
        }
        this.parent.postMessage({
            postmate: 'emit',
            type: messageType,
            value: {
                name: name,
                data: data,
            },
        }, this.parentOrigin);
    };
    return ChildAPI;
}());
/**
  * The entry point of the Parent.
 * @type {Class}
 */
var Postmate = /** @class */ (function () {
    /**
     * Sets options related to the Parent
     * @param {Object} object The element to inject the frame into, and the url
     * @return {Promise}
     */
    function Postmate(_a) {
        var _b = _a.container, container = _b === void 0 ? typeof container !== 'undefined' ? container : document.body : _b, // eslint-disable-line no-use-before-define
        model = _a.model, url = _a.url, name = _a.name, _c = _a.classListArray, classListArray = _c === void 0 ? [] : _c;
        this.parent = window;
        this.frame = document.createElement('iframe');
        this.frame.name = name || '';
        this.frame.classList.add.apply(this.frame.classList, classListArray);
        container.appendChild(this.frame);
        this.child = this.frame.contentWindow || this.frame.contentDocument.parentWindow;
        this.model = model || {};
        return this.sendHandshake(url);
    }
    /**
     * Begins the handshake strategy
     * @param  {String} url The URL to send a handshake request to
     * @return {Promise}     Promise that resolves when the handshake is complete
     */
    Postmate.prototype.sendHandshake = function (url) {
        var _this = this;
        var childOrigin = resolveOrigin(url);
        var attempt = 0;
        var responseInterval;
        return new Postmate.Promise(function (resolve, reject) {
            var reply = function (e) {
                if (!sanitize(e, childOrigin))
                    return false;
                if (e.data.postmate === 'handshake-reply') {
                    clearInterval(responseInterval);
                    if (process.env.NODE_ENV !== 'production') {
                        log('Parent: Received handshake reply from Child');
                    }
                    _this.parent.removeEventListener('message', reply, false);
                    _this.childOrigin = e.origin;
                    if (process.env.NODE_ENV !== 'production') {
                        log('Parent: Saving Child origin', _this.childOrigin);
                    }
                    return resolve(new ParentAPI(_this));
                }
            };
            _this.parent.addEventListener('message', reply, false);
            var doSend = function () {
                attempt++;
                if (process.env.NODE_ENV !== 'production') {
                    log("Parent: Sending handshake attempt " + attempt, { childOrigin: childOrigin });
                }
                _this.child.postMessage({
                    postmate: 'handshake',
                    type: messageType,
                    model: _this.model,
                }, childOrigin);
                if (attempt === maxHandshakeRequests) {
                    clearInterval(responseInterval);
                }
            };
            var loaded = function () {
                doSend();
                responseInterval = setInterval(doSend, 500);
            };
            if (_this.frame.attachEvent) {
                _this.frame.attachEvent('onload', loaded);
            }
            else {
                _this.frame.addEventListener('load', loaded);
            }
            if (process.env.NODE_ENV !== 'production') {
                log('Parent: Loading frame', { url: url });
            }
            _this.frame.src = url;
        });
    };
    Postmate.debug = false; // eslint-disable-line no-undef
    // Internet Explorer craps itself
    Postmate.Promise = (function () {
        try {
            return window ? window.Promise : Promise;
        }
        catch (e) {
            return null;
        }
    })();
    return Postmate;
}());
/**
 * The entry point of the Child
 * @type {Class}
 */
Postmate.Model = /** @class */ (function () {
    /**
     * Initializes the child, model, parent, and responds to the Parents handshake
     * @param {Object} model Hash of values, functions, or promises
     * @return {Promise}       The Promise that resolves when the handshake has been received
     */
    function Model(model) {
        this.child = window;
        this.model = model;
        this.parent = this.child.parent;
        return this.sendHandshakeReply();
    }
    /**
     * Responds to a handshake initiated by the Parent
     * @return {Promise} Resolves an object that exposes an API for the Child
     */
    Model.prototype.sendHandshakeReply = function () {
        var _this = this;
        return new Postmate.Promise(function (resolve, reject) {
            var shake = function (e) {
                if (!e.data.postmate) {
                    return;
                }
                if (e.data.postmate === 'handshake') {
                    if (process.env.NODE_ENV !== 'production') {
                        log('Child: Received handshake from Parent');
                    }
                    _this.child.removeEventListener('message', shake, false);
                    if (process.env.NODE_ENV !== 'production') {
                        log('Child: Sending handshake reply to Parent');
                    }
                    e.source.postMessage({
                        postmate: 'handshake-reply',
                        type: messageType,
                    }, e.origin);
                    _this.parentOrigin = e.origin;
                    // Extend model with the one provided by the parent
                    var defaults_1 = e.data.model;
                    if (defaults_1) {
                        Object.keys(defaults_1).forEach(function (key) {
                            _this.model[key] = defaults_1[key];
                        });
                        if (process.env.NODE_ENV !== 'production') {
                            log('Child: Inherited and extended model from Parent');
                        }
                    }
                    if (process.env.NODE_ENV !== 'production') {
                        log('Child: Saving Parent origin', _this.parentOrigin);
                    }
                    return resolve(new ChildAPI(_this));
                }
                return reject('Handshake Reply Failed');
            };
            _this.child.addEventListener('message', shake, false);
        });
    };
    return Model;
}());

var IframeTokenSource = /** @class */ (function () {
    function IframeTokenSource(client, env) {
        var _a, _b;
        this.client = client;
        this.env = env;
        var clientConfig = this.client.config;
        var query = {
            env: clientConfig.env,
            clientId: clientConfig.clientId,
            clientSecret: clientConfig.clientSecret,
            debug: clientConfig.debug,
            deviceId: getUserDeviceId(),
            bizCode: clientConfig.bizCode,
            tokenEndpoint: clientConfig.tokenEndpoint,
            tokenMethod: clientConfig.tokenMethod,
            name: (_a = clientConfig.name) !== null && _a !== void 0 ? _a : 'ums',
            tokenKey: clientConfig.scopeToken ? clientConfig.clientId + "." + TOKEN_KEY : clientConfig.tokenKey,
        };
        var name = query.name + "-source";
        var iframeTokenSourceURL = (_b = clientConfig.iframeTokenSourceURL) !== null && _b !== void 0 ? _b : envConfigMap[this.env].iframeTokenSourceURL;
        var url = iframeTokenSourceURL + qs.stringify(query, { addQueryPrefix: true });
        this._handshake = new Postmate({
            url: url,
            name: name,
            // @ts-ignore
            classListArray: [name]
        });
        var style = document.createElement('style');
        style.setAttribute('type', 'text/css');
        style.textContent = "." + name + " { display: none; }";
        document.head.appendChild(style);
        this._iframeStyle = style;
    }
    IframeTokenSource.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var child, accessToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._handshake];
                    case 1:
                        child = _a.sent();
                        return [4 /*yield*/, child.get('getAccessToken')];
                    case 2:
                        accessToken = _a.sent();
                        this._log('Access token:', accessToken);
                        return [2 /*return*/, accessToken];
                }
            });
        });
    };
    IframeTokenSource.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._handshake];
                    case 1:
                        child = _a.sent();
                        // @ts-ignore
                        return [2 /*return*/, child.get('getToken')];
                }
            });
        });
    };
    IframeTokenSource.prototype.setToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._handshake];
                    case 1:
                        child = _a.sent();
                        // @ts-ignore
                        return [4 /*yield*/, child.get('setToken', token)];
                    case 2:
                        // @ts-ignore
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    IframeTokenSource.prototype.clearToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._handshake];
                    case 1:
                        child = _a.sent();
                        // @ts-ignore
                        return [2 /*return*/, child.get('clearToken')];
                }
            });
        });
    };
    IframeTokenSource.prototype.login = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._handshake];
                    case 1:
                        child = _a.sent();
                        // @ts-ignore
                        return [2 /*return*/, child.get('login', token)];
                }
            });
        });
    };
    IframeTokenSource.prototype.setOrgId = function (org_id) {
        return __awaiter(this, void 0, void 0, function () {
            var child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._handshake];
                    case 1:
                        child = _a.sent();
                        // @ts-ignore
                        return [2 /*return*/, child.get('setOrgId', org_id)];
                }
            });
        });
    };
    IframeTokenSource.prototype.getOrgId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._handshake];
                    case 1:
                        child = _a.sent();
                        // @ts-ignore
                        return [2 /*return*/, child.get('getOrgId')];
                }
            });
        });
    };
    IframeTokenSource.prototype.setExtraData = function (key, data) {
        return __awaiter(this, void 0, void 0, function () {
            var child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._handshake];
                    case 1:
                        child = _a.sent();
                        // @ts-ignore
                        return [2 /*return*/, child.get('setExtraData', { key: key, data: data })];
                }
            });
        });
    };
    IframeTokenSource.prototype.getExtraData = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var child;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._handshake];
                    case 1:
                        child = _a.sent();
                        // @ts-ignore
                        return [2 /*return*/, child.get('getExtraData', key)];
                }
            });
        });
    };
    IframeTokenSource.prototype._log = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (this.client.debug) {
            console.log.apply(console, __spreadArrays(["[IframeTokenSource] " + message], optionalParams));
        }
    };
    return IframeTokenSource;
}());

var EmptyTokenSource = /** @class */ (function () {
    function EmptyTokenSource() {
    }
    EmptyTokenSource.prototype.setup = function () { };
    EmptyTokenSource.prototype.teardown = function () { };
    EmptyTokenSource.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, undefined];
            });
        });
    };
    EmptyTokenSource.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, null];
            });
        });
    };
    EmptyTokenSource.prototype.setToken = function (_) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    EmptyTokenSource.prototype.getOrgId = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ''];
            });
        });
    };
    EmptyTokenSource.prototype.setOrgId = function (_) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    EmptyTokenSource.prototype.setExtraData = function (key, data) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    EmptyTokenSource.prototype.getExtraData = function (key) {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    EmptyTokenSource.prototype.clearToken = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    return EmptyTokenSource;
}());

var ElectronTokenSource = /** @class */ (function (_super) {
    __extends(ElectronTokenSource, _super);
    function ElectronTokenSource(client, tokenSource) {
        var _this = _super.call(this, client) || this;
        _this.client = client;
        if (!tokenSource) {
            throw new Error('please provide tokenSource configuration');
        }
        _this.tokenSource = tokenSource;
        return _this;
    }
    ElectronTokenSource.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.tokenSource.getToken()];
            });
        });
    };
    ElectronTokenSource.prototype.setToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.tokenSource.setToken(token);
                return [2 /*return*/];
            });
        });
    };
    ElectronTokenSource.prototype.clearToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.tokenSource.clearToken();
                return [2 /*return*/];
            });
        });
    };
    ElectronTokenSource.prototype._getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getToken()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ElectronTokenSource;
}(LocalStorageTokenSource));

var OAuth2Client = /** @class */ (function () {
    function OAuth2Client(config) {
        var _a;
        this.config = config;
        this._schema = 'Bearer';
        this._defaultHeadersConfig = {
            'X-Biz-Code': '1',
            'X-Guest-Token': (_a = getUserDeviceId()) !== null && _a !== void 0 ? _a : ''
        };
        if (inBrowser && window.__OAUTH2_CLIENT__) {
            return window.__OAUTH2_CLIENT__;
        }
        if (OAuth2Client.instance) {
            return OAuth2Client.instance;
        }
        var _b = config.env, env = _b === void 0 ? Env.Prod : _b, _c = config.tokenSourceType, tokenSourceType = _c === void 0 ? TokenSourceType.Iframe : _c, _d = config.debug, debug = _d === void 0 ? false : _d;
        invariant(env === Env.Dev || env === Env.Stage || env === Env.Prod || env === Env.Fat, 'config env should be one of ["env", "stage", "prod", "fat"]');
        invariant(tokenSourceType === TokenSourceType.LocalStorage || tokenSourceType === TokenSourceType.Iframe || tokenSourceType === TokenSourceType.Electron, 'config tokenSourceType should be oneof ["localStorage", "iframe", "electron"]');
        if (!this.hasConfig(config, 'clientId')) {
            config.clientId = envConfigMap[env].clientId;
        }
        if (!this.hasConfig(config, 'clientSecret')) {
            config.clientSecret = envConfigMap[env].clientSecret;
        }
        if (!this.hasConfig(config, 'tokenEndpoint')) {
            config.tokenEndpoint = envConfigMap[env].tokenEndpoint;
        }
        if (!this.hasConfig(config, 'tokenMethod')) {
            config.tokenMethod = 'post';
        }
        if (!this.hasConfig(config, 'authorizationEndpoint')) {
            config.authorizationEndpoint = envConfigMap[env].authorizationEndpoint;
        }
        if (!this.hasConfig(config, 'redirectURI')) {
            config.redirectURI = envConfigMap[env].redirectURI;
        }
        if (!this.hasConfig(config, 'qiyeSsoURI')) {
            config.qiyeSsoURI = envConfigMap[env].qiyeSsoURI;
        }
        if (!inBrowser) {
            this._tokenSource = new EmptyTokenSource();
        }
        else if (tokenSourceType === TokenSourceType.LocalStorage) {
            this._tokenSource = new LocalStorageTokenSource(this);
        }
        else if (tokenSourceType === TokenSourceType.Iframe) {
            this._tokenSource = new IframeTokenSource(this, env);
        }
        if (config.tokenSource) {
            this._tokenSource = config.tokenSource;
        }
        if (tokenSourceType === TokenSourceType.Electron) {
            this._tokenSource = new ElectronTokenSource(this, config.tokenSource);
        }
        this.debug = debug;
        if (inBrowser) {
            window.__OAUTH2_CLIENT__ = this;
        }
        else {
            OAuth2Client.instance = this;
        }
    }
    OAuth2Client.prototype.login = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (token) {
                    return [2 /*return*/, this.setToken(token)];
                }
                return [2 /*return*/];
            });
        });
    };
    OAuth2Client.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.clearToken()];
            });
        });
    };
    OAuth2Client.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var accessToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._tokenSource.getAccessToken()];
                    case 1:
                        accessToken = _a.sent();
                        return [2 /*return*/, accessToken];
                }
            });
        });
    };
    OAuth2Client.prototype.getToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._tokenSource.getToken()];
            });
        });
    };
    OAuth2Client.prototype.setToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._tokenSource.setToken(this._sanitize(token))];
            });
        });
    };
    OAuth2Client.prototype.setOrgId = function (org_id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._tokenSource.setOrgId(org_id)];
            });
        });
    };
    OAuth2Client.prototype.getOrgId = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._tokenSource.getOrgId()];
            });
        });
    };
    OAuth2Client.prototype.setExtraData = function (key, data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._tokenSource.setExtraData(key, data)];
            });
        });
    };
    OAuth2Client.prototype.getExtraData = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._tokenSource.getExtraData(key)];
            });
        });
    };
    OAuth2Client.prototype.clearToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._tokenSource.clearToken()];
            });
        });
    };
    OAuth2Client.prototype.getAuthorizationHeader = function () {
        return __awaiter(this, void 0, void 0, function () {
            var accessToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAccessToken()];
                    case 1:
                        accessToken = _a.sent();
                        if (accessToken) {
                            return [2 /*return*/, this._schema + " " + accessToken];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    OAuth2Client.prototype.hasConfig = function (config, key) {
        return Object.prototype.hasOwnProperty.call(config, key);
    };
    OAuth2Client.prototype.launchPasswordCredentialsFlow = function (data, headers) {
        return __awaiter(this, void 0, void 0, function () {
            var passwordRequest, assignHeaders, response, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        passwordRequest = new PasswordRequest(__assign({ grantType: 'password', clientId: this.config.clientId, clientSecret: this.config.clientSecret, os: getOS() }, data));
                        assignHeaders = this._assignHeaders(headers);
                        return [4 /*yield*/, http.post(this.config.tokenEndpoint, passwordRequest.toSnakeCase(), {
                                headers: assignHeaders
                            })];
                    case 1:
                        response = _a.sent();
                        token = this._sanitize(response.data);
                        return [4 /*yield*/, this._tokenSource.setToken(token)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, token];
                }
            });
        });
    };
    OAuth2Client.prototype.launchVerifyCodeFlow = function (data, headers) {
        return __awaiter(this, void 0, void 0, function () {
            var verifyCodeRequest, assignHeaders, response, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        verifyCodeRequest = new VerifyCodeRequest(__assign({ grantType: 'verify-code', clientId: this.config.clientId, clientSecret: this.config.clientSecret, os: getOS() }, data));
                        assignHeaders = this._assignHeaders(headers);
                        return [4 /*yield*/, http.post(this.config.tokenEndpoint, verifyCodeRequest.toSnakeCase(), {
                                headers: assignHeaders
                            })];
                    case 1:
                        response = _a.sent();
                        token = this._sanitize(response.data);
                        return [4 /*yield*/, this._tokenSource.setToken(token)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, token];
                }
            });
        });
    };
    OAuth2Client.prototype.launchAuthorizationCodeFlow = function (data, headers) {
        return __awaiter(this, void 0, void 0, function () {
            var authorizationCodeRequest, assignHeaders, response, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        authorizationCodeRequest = new AuthorizationCodeRequest(__assign({ grantType: 'authorization_code', clientId: this.config.clientId, clientSecret: this.config.clientSecret, os: getOS() }, data));
                        assignHeaders = this._assignHeaders(headers);
                        return [4 /*yield*/, http.post(this.config.tokenEndpoint, authorizationCodeRequest.toSnakeCase(), {
                                headers: assignHeaders
                            })];
                    case 1:
                        response = _a.sent();
                        token = this._sanitize(response.data);
                        return [4 /*yield*/, this._tokenSource.setToken(token)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, token];
                }
            });
        });
    };
    OAuth2Client.prototype.launchThirdPartyFlow = function (data, headers) {
        return __awaiter(this, void 0, void 0, function () {
            var thirdPartyRequest, assignHeaders, response, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        thirdPartyRequest = new ThirdPartyRequest(__assign({ clientId: this.config.clientId, clientSecret: this.config.clientSecret, os: getOS() }, data));
                        assignHeaders = this._assignHeaders(headers);
                        return [4 /*yield*/, http.post(this.config.tokenEndpoint, thirdPartyRequest.toSnakeCase(), {
                                headers: assignHeaders
                            })];
                    case 1:
                        response = _a.sent();
                        token = this._sanitize(response.data);
                        return [4 /*yield*/, this._tokenSource.setToken(token)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, token];
                }
            });
        });
    };
    OAuth2Client.prototype.launchRefreshTokenFlow = function (data, headers) {
        return __awaiter(this, void 0, void 0, function () {
            var refreshTokenRequest, response, assignHeaders, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        refreshTokenRequest = new RefreshTokenRequest(__assign({ grantType: 'refresh_token', clientId: this.config.clientId, clientSecret: this.config.clientSecret, os: getOS() }, data));
                        assignHeaders = this._assignHeaders(headers);
                        if (!(this.config.tokenMethod === 'post')) return [3 /*break*/, 2];
                        return [4 /*yield*/, http.post(this.config.tokenEndpoint, refreshTokenRequest.toSnakeCase(), {
                                headers: assignHeaders
                            })];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, http.get(this.config.tokenEndpoint, {
                            params: refreshTokenRequest.toSnakeCase(),
                            headers: assignHeaders
                        })];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4:
                        token = this._sanitize(response.data);
                        return [2 /*return*/, token];
                }
            });
        });
    };
    OAuth2Client.prototype.authorizationRedirectURI = function (state, extendQuery) {
        if (state === void 0) { state = ''; }
        if (extendQuery === void 0) { extendQuery = {}; }
        invariant(this.config.redirectURI, 'redirectURI is required.');
        var query = __assign(__assign({}, extendQuery), { tokenKey: this.config.scopeToken ? this.config.clientId + "." + TOKEN_KEY : this.config.tokenKey, appid: this.config.clientId, redirect_uri: this.config.redirectURI, referer_uri: this.config.ssoRedirectURI, state: state, guest_token: getUserDeviceId() });
        var redirectUrl = this.config.authorizationEndpoint + "?" + qs.stringify(query);
        console.log(redirectUrl, 'authorizationRedirectURI');
        return redirectUrl;
    };
    /**
     * 刷 org_id
     * https://doc.huanleguang.com/pages/viewpage.action?pageId=201254336
     * @param data
     * @param headers
     */
    OAuth2Client.prototype.launchreRreshOrgIdFlow = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _org_id, token, formData, refreshOrgIdRequest, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _org_id = '';
                        return [4 /*yield*/, this.getToken()];
                    case 1:
                        token = _a.sent();
                        if (!!(data && data.org_id)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getOrgId()];
                    case 2:
                        _org_id = _a.sent();
                        _a.label = 3;
                    case 3:
                        formData = Object.assign({
                            org_id: _org_id,
                            access_token: (token === null || token === void 0 ? void 0 : token.access_token) || '',
                            refresh_token: (token === null || token === void 0 ? void 0 : token.refresh_token) || ''
                        }, data);
                        refreshOrgIdRequest = new RefreshOrgIdRequest(__assign({}, formData));
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 7, , 8]);
                        return [4 /*yield*/, http.post(this.config.qiyeSsoURI + "/api/token/org-bind", refreshOrgIdRequest.toSnakeCase())];
                    case 5:
                        response = _a.sent();
                        return [4 /*yield*/, this._tokenSource.setOrgId(data.org_id)];
                    case 6:
                        _a.sent();
                        return [2 /*return*/, response];
                    case 7:
                        error_1 = _a.sent();
                        return [2 /*return*/, null];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    OAuth2Client.prototype.launchreClearToken = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var assignHeaders, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!data.access_token) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        assignHeaders = this._assignHeaders({
                            'x-appid': this.config.clientId,
                            'Authorization': "Bearer " + data.access_token
                        });
                        return [4 /*yield*/, http.delete(this.config.tokenEndpoint, { headers: assignHeaders })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OAuth2Client.prototype._sanitize = function (data) {
        return {
            access_token: data.access_token,
            expires_in: data.expires_in,
            access_token_expires_at: data.access_token_expires_at,
            access_token_life_time: data.access_token_life_time,
            refresh_token: data.refresh_token,
            refresh_token_expires_in: data.refresh_token_expires_in,
            refresh_token_expires_at: data.refresh_token_expires_at,
            refresh_token_life_time: data.refresh_token_life_time,
            ticket: data.ticket,
            org_id: data.org_id,
            timestamp: Date.now()
        };
    };
    OAuth2Client.prototype._assignHeaders = function (headers) {
        var headersConfig = {};
        if (this.config.deviceId) {
            headersConfig['X-Guest-Token'] = this.config.deviceId;
        }
        if (this.config.bizCode) {
            headersConfig['X-Biz-Code'] = this.config.bizCode;
        }
        return Object.assign({}, this._defaultHeadersConfig, headersConfig, headers);
    };
    OAuth2Client.prototype._log = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (this.debug) {
            console.log.apply(console, __spreadArrays(["[OAuth2Client] " + message], optionalParams));
        }
    };
    return OAuth2Client;
}());

export { OAuth2Client };
